import { focusOnWordByWordByUsingGraphic, focusOnWordByWordByUsingOpacity } from "./fancyCaptions";
// lotsOfText();
// skewedText();
// graphicStyles();
focusOnWordByWordByUsingOpacity();
focusOnWordByWordByUsingGraphic();
